/**
 * File to run the Google API's for the food bank
 * archive page.
 */
document.addEventListener("DOMContentLoaded", function () {
  const zipForm = document.getElementById("zipSearch");
  const filterForm = document.getElementById("bankFilter");
  const filters = document.getElementById("foodFilter");
  const filtersTxt = filters.innerHTML;
  const apiKey = "AIzaSyBvL7EJszYV7cXPD035eKjadeBbmC6f9-o";
  const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json`;
  const loading = document.querySelector(".loading-ring");

  filters.addEventListener("click", (e) => {
    document
      .querySelector(".food-bank__header--filter-bar")
      .classList.toggle("is-active");

    if (
      document
        .querySelector(".food-bank__header--filter-bar")
        .classList.contains("is-active")
    ) {
      filters.innerHTML = 'close filters <i class="icon-close"></i>';
    } else {
      filters.innerHTML = filtersTxt;
    }
  });

  zipForm.addEventListener("submit", (e) => {
    e.preventDefault();

    var zipCode = document.getElementById("zipcode").value;

    loading.classList.add("is-active");

    if (!zipCode) return;

    var url = `${apiUrl}?address=${zipCode}&key=${apiKey}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "OK") {
          var lat = "";
          var lng = "";

          // console.log("results");
          // console.log(data.results);
          console.log(data);

          data.results.forEach((result) => {
            let isUS = false;
            let isPA = false;

            result.address_components.forEach((component) => {
              if (
                component.types.includes("administrative_area_level_1") &&
                component.long_name === "Pennsylvania"
              ) {
                isPA = true;
              }
            });

            if (isPA) {
              lat = result.geometry.location.lat;
              lng = result.geometry.location.lng;
            }
          });

          fetch(zipCodeAjax.ajaxurl, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              action: "find_closest_location",
              lat: lat,
              lng: lng,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.data.post) {
                document
                  .querySelector(".food-bank__table")
                  .classList.add("is-hidden");

                document
                  .querySelector("#postResult")
                  .classList.add("is-active");

                document
                  .getElementById("clearFilters")
                  .classList.add("is-active");

                document.getElementById("update-message").textContent =
                  "Food Bank details has been updated.";

                document.querySelector(".food-bank-container").focus();

                document.querySelector("#postResult").innerHTML = JSON.parse(
                  data.data.post
                );
              }

              setTimeout(() => {
                loading.classList.remove("is-active");
              }, 500);
            });
        } else {
          alert("Unable to get coordinates for the provided ZIP code.");

          setTimeout(() => {
            loading.classList.remove("is-active");
          }, 500);
        }
      })
      .catch((error) => {
        console.error("Error fetching geolocation data:", error);

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 500);
      });
  });

  document.getElementById("bankFilter").addEventListener("change", (e) => {
    e.preventDefault();

    const county = document.getElementById("county").value;
    const restUrl = `${window.location.origin}/wp-json/feeding_pa/v1/filter_by_county?county=${county}`;

    document.getElementById("countySelected").innerHTML = county + " county";

    loading.classList.add("is-active");

    fetch(restUrl)
      .then((response) => response.json())
      .then((data) => {
        var nData = JSON.parse(data);

        document.getElementById("update-message").textContent =
          "Food Bank details has been updated.";

        document.querySelector(".food-bank-container").focus();

        document.querySelector(".food-bank__header--count").innerHTML =
          nData.count + " Food Banks";

        document.querySelector(".food-bank__table-body").innerHTML =
          nData.posts;

        document.getElementById("clearFilters").classList.add("is-active");

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 1000);
      })
      .catch((error) => {
        loading.classList.add("is-active");

        console.error("Error fetching posts from REST API:", error);
        document.querySelector(".food-bank__table-body").innerHTML = error;
        document.getElementById("clearFilters").classList.add("is-active");

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 1000);
      });
  });

  document.getElementById("clearFilters").addEventListener("click", (e) => {
    e.preventDefault();

    const restUrl = `${window.location.origin}/wp-json/feeding_pa/v1/filter_by_county`;

    loading.classList.add("is-active");

    document.getElementById("countySelected").innerHTML = "county";

    fetch(restUrl)
      .then((response) => response.json())
      .then((data) => {
        var nData = JSON.parse(data);

        document.querySelector(".food-bank__header--count").innerHTML =
          nData.count + " Food Banks";

        document.querySelector(".food-bank__table-body").innerHTML =
          nData.posts;

        document.getElementById("clearFilters").classList.remove("is-active");
        document
          .querySelector(".food-bank__table")
          .classList.remove("is-hidden");
        document.querySelector("#postResult").classList.remove("is-active");
        document.getElementById("zipcode").value = "";

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 500);
      })
      .catch((error) => {
        console.error("Error fetching posts from REST API:", error);
        document.querySelector(".food-bank__table-body").innerHTML = error;
        document.getElementById("clearFilters").classList.remove("is-active");

        setTimeout(() => {
          loading.classList.remove("is-active");
        }, 500);
      });
  });
});
